import { appendScriptToHead } from 'utils/DOMUtils';
import Cookie from 'utils/cookies';
import { gaWrapper } from 'helpers/analytics';
//import useFetch from 'utils/hooks/useFetch';
import {
  TOI_SUBS_INITIATE_JUSPAY_SDK_MWEB,
  TOI_SUBS_INITIATE_JUSPAY_SDK_WEB,
  PRC_FOR_SUBSCRIBED,
  TOI_SUBS_FETCH_PLAN_STATUS_MWEB,
  TOI_SUBS_FETCH_PLAN_STATUS_WEB,
  PRC_FOR_SUBSCRIPTION_EXPIRED,
  Plan,
  TOI_PLUS_PLAN_PAGE_URL,
} from 'constants/index';
import {
  fireCustomDimension,
  reloadIfPaidStory,
  checkIfPaidStory,
  reloadWrtPrimeUnlock,
} from 'utils/common';
import { loginEventEmitter, loginCredEmitter } from 'components/Login';
import makeRequest from 'utils/makeRequest';
import { redirectToPlanPage } from './redirectionToPlanPage';
import { storeOrderInfo } from '../utils/browserStorageData';
import processOrder from '../utils/orderApi';

const loadPaymentSdk = () => {
  appendScriptToHead({ scriptUrl: 'https://payments.juspay.in/web/PIL.js' });
};

const gotoPaymentPage = (JuspayPaymentsSdk, orderData) => {
  const bundle = {};
  const { PaymentConstants } = JuspayPaymentsSdk;
  const juspayProcessData = orderData?.juspayProcessData;
  bundle[PaymentConstants.MERCHANT_KEY_ID] =
    juspayProcessData?.payload?.merchantKeyId;
  bundle[PaymentConstants.CLIENT_ID] = juspayProcessData?.payload?.clientId;
  bundle[PaymentConstants.ORDER_DETAILS] =
    juspayProcessData?.payload?.orderDetails;
  bundle[PaymentConstants.SIGNATURE] = juspayProcessData?.payload?.signature;
  bundle.environment = juspayProcessData?.payload?.environment;
  bundle[PaymentConstants.CUSTOMER_ID] = juspayProcessData?.payload?.customerId;
  JuspayPaymentsSdk.startApp(bundle);
};
let paymentRes = {};
const storePlanDataAndReloadIfRequired = plan => {
  if (plan === 'credOption') {
    if (__PROD__) {
      window.location.reload();
    } else {
      const checkForCreateOrderFailure =
        localStorage.getItem('toi_subscription') &&
        JSON.parse(localStorage.getItem('toi_subscription'))?.orderStatus;
      if (checkForCreateOrderFailure) {
        window.location.reload();
      } else {
        reloadWrtPrimeUnlock();
      }
    }
  }
};
const choosePlanAndInitiatePayment = async (
  planId,
  getPaymentInitData,
  initPaymentRes,
  createOrder,
  prcValue,
  isWapView,
  geoCountry,
  currencyCode,
  msid = null,
  inPreExpirePeriod,
  inGracePeriod,
  userType,
  remainingDays,
) => {
  const currentUrl = window.location.href;
  const currUrlObj = new URL(currentUrl);
  const options = {};
  options.ssoId = Cookie.get('ssoid') || Cookie.get('ssoId') || '';
  options.ticketId = Cookie.get('TicketId') || Cookie.get('ticket') || '';
  options.utmParams = {
    source: currUrlObj.searchParams.get('utm_source') || null,
    medium: currUrlObj.searchParams.get('utm_medium') || null,
    campaign: currUrlObj.searchParams.get('utm_campaign') || null,
  };

  const sandBoxPlayground =
    currUrlObj.searchParams.get('justpaysandbox') === 'true' ? 'SANDBOX' : '1';

  options.paymentMode = 'JUSPAY';
  // const { post: getPaymentInitData, response: initPaymentRes } = useFetch({});
  // const { post: createOrder } = useFetch({});
  const paymentInitData = await getPaymentInitData({
    url: `${
      isWapView
        ? TOI_SUBS_INITIATE_JUSPAY_SDK_MWEB
        : TOI_SUBS_INITIATE_JUSPAY_SDK_WEB
    }&cc=${geoCountry}`,
    options,
  });
  const firePurchaseTypeDimension = () => {
    let newPurschaseType;
    if (userType === 'tp') {
      newPurschaseType = 'new';
    } else if (
      userType !== 'tp' &&
      prcValue === PRC_FOR_SUBSCRIBED &&
      inGracePeriod
    ) {
      newPurschaseType = 'Grace_renew';
    } else if (userType !== 'tp' && prcValue === PRC_FOR_SUBSCRIBED) {
      newPurschaseType = 'Renew';
    } else if (userType !== 'tp' && prcValue === PRC_FOR_SUBSCRIPTION_EXPIRED) {
      newPurschaseType = 'Expired';
    } else if (userType !== 'tp') {
      newPurschaseType = 'new';
    }
    fireCustomDimension(newPurschaseType, 'dimension53');
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('newPurschaseType', newPurschaseType);
    }
  };
  if (paymentInitData && paymentInitData.data && paymentInitData.data.data) {
    const orderData = await processOrder(
      createOrder,
      planId,
      isWapView,
      geoCountry,
      msid,
    );
    if (
      orderData &&
      orderData.data &&
      orderData.data.status &&
      !orderData.data.data
    ) {
      if (orderData.data.status === 'FAILED') {
        storeOrderInfo(orderData.data.data, orderData.data.statusCode);
      }
    }
    if (orderData && orderData.data && orderData.data.data) {
      if (planId !== Plan.CRED) {
        new Promise(resolve => {
          resolve(
            window.PIL.load(sandBoxPlayground, paymentInitData.data.data),
          );
        }).then(JuspayPaymentsSdk => {
          if (JuspayPaymentsSdk) {
            if (typeof window !== 'undefined') {
              fireCustomDimension(currencyCode, 'dimension38');
              if (
                orderData.data.data.orderDetails &&
                orderData.data.data.orderDetails.orderId
              ) {
                fireCustomDimension(
                  orderData.data.data.orderDetails.orderId,
                  'dimension50',
                );
                if (remainingDays > -1) {
                  if (inGracePeriod) {
                    fireCustomDimension(remainingDays, 'dimension52');
                  } else if (inPreExpirePeriod) {
                    fireCustomDimension(remainingDays, 'dimension51');
                  }
                }
                if (planId) {
                  firePurchaseTypeDimension();
                }
              }
              gaWrapper(
                'send',
                'event',
                window.categoryForGA,
                `TOIPlus_OrderCreate`,
                `Ps-${prcValue || 0}`,
              );
              if (typeof window !== 'undefined' && window.localStorage) {
                localStorage.removeItem('retry_popup_closed');
              }
            }
            storeOrderInfo(orderData.data.data);
            gotoPaymentPage(JuspayPaymentsSdk, orderData.data.data);
          }
        });
        storePlanDataAndReloadIfRequired('others');
      } else if (planId === Plan.CRED) {
        if (typeof window !== 'undefined') {
          gaWrapper(
            'send',
            'event',
            window.categoryForGA,
            `TOIPlus_OrderCreate`,
            `Ps-${prcValue || 0}`,
          );
        }
        if (
          orderData.data.data?.orderDetails?.paymentStatus === 'PAYMENT_FAILED'
        ) {
          storeOrderInfo(
            orderData.data.data,
            orderData.data.data?.orderDetails?.paymentError,
          );
        } else {
          storeOrderInfo(orderData.data.data);
        }
        storePlanDataAndReloadIfRequired('credOption');
      }
    }
  }
};
const getPaymentInitData = async reqParams => {
  let res;
  try {
    res = await makeRequest.post(
      reqParams.url,
      reqParams.options,
      reqParams.headers,
    );
    paymentRes = res;
  } catch (err) {
    console.log(err);
  }
  return res;
};
const createOrder = async reqParams => {
  let res;
  try {
    res = await makeRequest.post(
      reqParams.url,
      reqParams.options,
      reqParams.headers,
    );
  } catch (err) {
    console.log(err);
    if (reqParams?.options?.productId === Plan.CRED) {
      storeOrderInfo(null, 'PaymentFailure');
      storePlanDataAndReloadIfRequired('credOption');
    }
  }
  return res;
};
const getPrcDataAPI = (userData, isWapView) => {
  if (userData && userData.isLoggedIn) {
    const url = isWapView
      ? TOI_SUBS_FETCH_PLAN_STATUS_MWEB
      : TOI_SUBS_FETCH_PLAN_STATUS_WEB;
    let ssoId = document.cookie.match(/(?:\s)?ssoid=(\w+);?/);
    ssoId = Array.isArray(ssoId) && ssoId[1];
    let ticketId = document.cookie.match(/(?:\s)?TicketId=(\w+);?/);
    ticketId = Array.isArray(ticketId) && ticketId[1];
    return makeRequest.get(url, {
      headers: {
        ticketId,
        ssoId,
      },
      params: {
        rspBody: true,
      },
    });
  }
  return null;
};
const startTOIPaymentFlow = (
  selectedPlanId,
  isWapView,
  geoCountry,
  translationData,
  userData,
  msid,
  offerAndJustPayRedirect = null,
) => {
  const { currencyCode } = translationData;
  userData.isLoggedIn = true;
  if (offerAndJustPayRedirect) {
    const {
      selectedPlan,
      inGracePeriod,
      ispreExpired,
      userType,
      daysRemaining,
      justPayRedirect,
      offer,
      pageType,
    } = offerAndJustPayRedirect;
    const getPrcDataAPIPromise = getPrcDataAPI(userData, isWapView);
    if (getPrcDataAPIPromise) {
      getPrcDataAPIPromise.then(res => {
        if (
          res &&
          res.status === 200 &&
          res.data &&
          typeof res.data === 'object'
        ) {
          const prcData = res.data;
          if (
            justPayRedirect &&
            prcData &&
            prcData.planStatus !== PRC_FOR_SUBSCRIBED
          ) {
            choosePlanAndInitiatePayment(
              selectedPlan,
              getPaymentInitData,
              {},
              createOrder,
              prcData.planStatus,
              isWapView,
              geoCountry,
              currencyCode,
              null,
              ispreExpired,
              inGracePeriod,
              userType,
              daysRemaining,
              //this.toggleTPslider,
              //this.state.validateMobileStatus,
            );
          } else if (offer) {
            choosePlanAndInitiatePayment(
              selectedPlan,
              getPaymentInitData,
              {},
              createOrder,
              prcData.planStatus,
              isWapView,
              geoCountry,
              currencyCode,
              null,
              ispreExpired,
              inGracePeriod,
              userType,
              daysRemaining,
              //this.toggleTPslider,
              //this.state.validateMobileStatus,
            );
          } else if (
            justPayRedirect &&
            prcData.planStatus === PRC_FOR_SUBSCRIBED &&
            window !== 'undefined' &&
            pageType === 'storypage'
          ) {
            window.location.href = redirectToPlanPage(
              TOI_PLUS_PLAN_PAGE_URL,
              true,
            );
          } else if (
            justPayRedirect &&
            prcData.planStatus === PRC_FOR_SUBSCRIBED &&
            window !== 'undefined' &&
            pageType !== 'storypage'
          ) {
            window.location.href = redirectToPlanPage(TOI_PLUS_PLAN_PAGE_URL);
          }
        }
      });
    }
  } else {
    getPrcDataAPI(userData, isWapView)
      .then(data => {
        //if (data?.data?.otps) {
        if (data && data.data && typeof data.data === 'object') {
          const prcData = data.data;
          reloadIfPaidStory(msid);
          if (
            prcData &&
            prcData.planStatus !== PRC_FOR_SUBSCRIBED &&
            msid &&
            !checkIfPaidStory(msid)
          ) {
            choosePlanAndInitiatePayment(
              selectedPlanId,
              getPaymentInitData,
              paymentRes,
              createOrder,
              prcData.planStatus,
              isWapView,
              geoCountry,
              currencyCode,
              msid,
              //this.toggleTPslider,
              //this.state.validateMobileStatus,
            );
          }
        }
        //}
      })
      .catch(err => console.log(err));
  }
};

const handlePlanClick = (
  msid,
  translationData,
  userData,
  isWapView,
  geoCountry,
  planId,
  offerAndJustPayRedirect = null,
) => {
  // const { isWapView, geoCountry, translationData, userData } = this.props;
  // const { isLoggedIn = undefined } = userData;
  userData = userData || {};
  const isLoggedIn = userData?.isLoggedIn ? userData?.isLoggedIn : undefined;
  const { currencyCode } = translationData;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
  let loginFn = loginEventEmitter;
  let dataObj = null;
  if (planId === Plan.CRED) {
    loginFn = loginCredEmitter;
    localStorage.setItem('planOption', JSON.stringify('credOption'));
  } else {
    dataObj = {
      showToiSubscriptionText: true,
      isPrimePaymentFlow: true,
    };
  }

  if (!isLoggedIn) {
    loginFn(
      startTOIPaymentFlow.bind(
        this,
        planId,
        isWapView,
        geoCountry,
        translationData,
        userData,
        msid,
        offerAndJustPayRedirect,
      ),
      dataObj,
    );
  } else if (msid) {
    if (checkIfPaidStory(msid)) {
      reloadIfPaidStory(msid);
    } else {
      choosePlanAndInitiatePayment(
        planId,
        getPaymentInitData,
        paymentRes,
        createOrder,
        prcValue,
        isWapView,
        geoCountry,
        currencyCode,
        msid,
      );
    }
  } else if (offerAndJustPayRedirect) {
    const {
      selectedPlan,
      inGracePeriod,
      ispreExpired,
      userType,
      daysRemaining,
      justPayRedirect,
    } = offerAndJustPayRedirect;
    if (justPayRedirect && prcValue !== PRC_FOR_SUBSCRIBED) {
      choosePlanAndInitiatePayment(
        selectedPlan,
        getPaymentInitData,
        paymentRes,
        createOrder,
        prcValue,
        isWapView,
        geoCountry,
        currencyCode,
        null,
        ispreExpired,
        inGracePeriod,
        userType,
        daysRemaining,
      );
    } else {
      choosePlanAndInitiatePayment(
        selectedPlan,
        getPaymentInitData,
        paymentRes,
        createOrder,
        prcValue,
        isWapView,
        geoCountry,
        currencyCode,
        null,
        ispreExpired,
        inGracePeriod,
        userType,
        daysRemaining,
      );
    }
  }
};

const storeCredToken = tokenData => {
  if (tokenData) {
    localStorage.setItem('cred_access_token', JSON.stringify(tokenData));
  }
};

const getCredBtnClickHandler = params => {
  let credKey = '4A1C2E464F29442788F9CC36CA2DA3EB';
  if (__PROD__) {
    credKey = '830103AE460240FFBE550FD76DC7CBB1';
  }
  const credAuth = window.CRED_ACCESS.init({
    publicKey: credKey,
    referrer: window.location.href,
  });

  // credAuth.renderButton(
  //   document.getElementById('credBtn'), // reference to button
  //   (code, requestId) => {
  //     // triggered when authentication happens via web
  //     if (!code) {
  //       // failure state
  //     } else {
  //       console.log('checking!!!!', code, requestId);
  //     }
  //   },
  //   requestId => {
  //     console.log('checking!!!!', requestId);
  //   },
  // );

  credAuth.handleAccessBtnClick(
    params.credRef, // reference to an empty div
    async (code, requestId) => {
      if (!code) {
        // failure state
        // user is not gated in CRED
      } else {
        params.credloaderFn(true);
        let tokenUrl =
          'https://subs.timesofindia.com/subscriptions/cred/access/';

        if (!__PROD__) {
          tokenUrl =
            'https://stgsubs.timesofindia.com/subscriptions/cred/access/';
        }
        const tokenRawResponse = await fetch(tokenUrl, {
          method: 'GET', // or 'PUT'
          headers: {
            'Content-Type': 'application/json',
            requestId,
            code,
          },
        });
        const tokenResponse = await tokenRawResponse.json();
        storeCredToken(tokenResponse?.data);
        const {
          msid,
          translationData,
          userData,
          isWapView,
          geoCountry,
          option,
        } = params;
        handlePlanClick(
          msid,
          translationData,
          userData,
          isWapView,
          geoCountry,
          option,
        );
        //loginCredEmitter(dataObj, credPrcOrderCreationFlow);
        // user is gated in call the API here
        // use the response show/set data.
      }
    }, // action with code
    async requestId => {
      if (requestId) {
        params.credloaderFn(true);
        let tokenUrl =
          'https://subs.timesofindia.com/subscriptions/cred/access/';

        if (!__PROD__) {
          tokenUrl =
            'https://stgsubs.timesofindia.com/subscriptions/cred/access/';
        }
        let tokenRawResponse;
        let tokenResponse;
        let pollCount = 0;
        (async function fetchTokenPolling() {
          tokenRawResponse = await fetch(tokenUrl, {
            method: 'GET', // or 'PUT'
            headers: {
              'Content-Type': 'application/json',
              requestId,
            },
          });
          tokenResponse = await tokenRawResponse.json();
          if (!tokenResponse?.data && pollCount < 3) {
            pollCount += 1;
            await new Promise(resolve => setTimeout(resolve, 2000));
            fetchTokenPolling();
          } else {
            storeCredToken(tokenResponse?.data);
            const {
              msid,
              translationData,
              userData,
              isWapView,
              geoCountry,
              option,
            } = params;
            handlePlanClick(
              msid,
              translationData,
              userData,
              isWapView,
              geoCountry,
              option,
            );
          }
        })();
      }
    },
  );
};
const loadCredSdk = params => {
  let credUrl = 'https://sdk.cred.club/cred-access-sdk.prod@v1.0.5.js';
  if (!__PROD__) {
    credUrl = 'https://sdk.cred.club/cred-access-sdk.stg@v1.0.8.js';
  }
  const credScript = document.createElement('script');
  credScript.src = credUrl;
  document.body.appendChild(credScript);
  // eslint-disable-next-line func-names
  credScript.onload = function() {
    getCredBtnClickHandler(params);
  };
};
const credUnlockFlow = params => {
  if (typeof window !== 'undefined' && window.CRED_ACCESS) {
    getCredBtnClickHandler(params);
  } else {
    loadCredSdk(params);
  }
};

export {
  loadPaymentSdk,
  choosePlanAndInitiatePayment,
  handlePlanClick,
  credUnlockFlow,
};
